export enum ALGOS_E {
  ALL = "all",
  SHA256 = "sha256",
  SCRIPT = "scrypt",
  EQUIHASH = "equihash",
}

export enum ALGOS_SPEED_NAMES {
  sha256 = "H",
  scrypt = "H",
  equihash = "Sol",
}

export function isAlgo(value: number | string | ALGOS_E): value is ALGOS_E {
  if (typeof value === "number") return false;
  return (
    [
      ALGOS_E.SCRIPT.toString(),
      ALGOS_E.SHA256.toString(),
      ALGOS_E.EQUIHASH.toString(),
    ].indexOf(value) > -1
  );
}